import styled, { css } from 'styled-components'
import { Box } from '../UI/Box'
import {
  ChainLogoProps,
  HeaderContainerProps,
  WalletButtonProps,
} from './types'
import { defaultTransition } from '../../theme'
import { getRgbaValue } from '../../utils/styling/getRgbaValue'
import { linkStyles } from '../ButtonRoute/styles'

export const pageWrapCssRules = css<{ maxWidth?: number }>`
  ${({ theme, maxWidth }) =>
    !!maxWidth
      ? `max-width: ${maxWidth + theme.layout.expandedPlus.indexGrids.margins * 2
      }px;`
      : ''}
  ${({ theme, maxWidth }) => {
    const { breakpoints } = theme
    const rules = []
    for (const [key, value] of Object.entries(breakpoints)) {
      const gutters = theme.layout[key].indexGrids.margins
      rules.push(
        `@media screen and (max-width: ${value}px) {
          max-width: ${!!maxWidth ? maxWidth + gutters * 2 : 'unset'}px;
          }
        }
      `,
      )
    }
    return rules.slice().reverse().join('\n')
  }}
`

export const pagePaddingCssRules = css`
  padding: 0 ${({ theme }) => theme.layout.expandedPlus.indexGrids.margins}px;
  ${({ theme }) => {
    const { breakpoints } = theme
    const rules = []
    for (const [key, value] of Object.entries(breakpoints)) {
      const gutters = theme.layout[key].indexGrids.margins
      rules.push(
        `@media screen and (max-width: ${value}px) {
            padding: 0 ${gutters}px; 
          }
        }
      `,
      )
    }
    return rules.slice().reverse().join('\n')
  }}
`

export const boxGapMarginsCssRules = css`
  gap: ${({ theme }) => theme.layout.expandedPlus.indexGrids.margins}px;
  ${({ theme }) => {
    const { breakpoints } = theme
    const rules = []
    for (const [key, value] of Object.entries(breakpoints)) {
      const gaps = theme.layout[key].indexGrids.margins
      rules.push(
        `@media screen and (max-width: ${value}px) { gap: ${gaps}px; }`,
      )
    }
    return rules.slice().reverse().join('\n')
  }}
`

export const boxGapGuttersCssRules = css`
  gap: ${({ theme }) => theme.layout.expandedPlus.indexGrids.gutters}px;
  ${({ theme }) => {
    const { breakpoints } = theme
    const rules = []
    for (const [key, value] of Object.entries(breakpoints)) {
      const gaps = theme.layout[key].indexGrids.gutters
      rules.push(
        `@media screen and (max-width: ${value}px) { gap: ${gaps}px; }`,
      )
    }
    return rules.slice().reverse().join('\n')
  }}
`

export const HeaderContainer = styled.div<HeaderContainerProps>`
  position: relative;
  z-index: 1001;
  min-height: 80px;
  z-index: 1001;
  min-height: 80px;
  align-items: center;
  max-width: 100%;
  background: var(--surface-minimal-alpha-primary, rgba(255, 255, 255, 0.04));
  padding: 0px var(--Index-Grids-Margins, 16px);
  ${({ hasBottomBorder }) =>
    hasBottomBorder && `border-bottom: 1px solid var(--stroke-secondary);`}

  .sticky-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: var(--surface-primary, #000);
    transition:
      top 0.3s ease-in-out,
      opacity 0.3s ease-in-out;
  }
`

export const HeaderContentContainer = styled(Box) <{ maxWidth?: number }>`
  min-height: 80px;
  display: grid;
  position: relative;
  z-index: 100;
  grid-auto-flow: column;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  margin: auto;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '100%')};
  ${pageWrapCssRules}
`

export const WalletButton = styled(Box) <WalletButtonProps>`
  @media screen and (max-width: 1000px) {
    min-width: ${({ isConnected, wrongNetwork }) =>
    isConnected && !wrongNetwork
      ? wrongNetwork
        ? '184px'
        : 'auto'
      : '180px'};
    margin: 0;
  }
  img.header-chevron {
    max-width: 20px;
    max-height: 20px;
  }
  img.user-avatar {
    width: 20px;
    height: 20px;
    max-width: 20px;
    max-height: 20px;
    border-radius: 50%;
  }
`

export const ConnectedWalletContainer = styled(Box)`
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
  }
`

export const LogosContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  gap: 8px;
  ${defaultTransition}
  :hover {
    cursor: pointer;
  }
  img {
    width: 100px;
    height: 32px;
  }
  min-width: 142px;
`

export const ChainLogo = styled.img<ChainLogoProps>`
${({ isButtonLogo }) => (isButtonLogo ? `height:16px;width:16px;` : '')}
filter:saturate(0) invert(${({ invert }) => (invert ? 1 : 0)});
  margin-${({ isButtonLogo }) => (isButtonLogo ? 'right' : 'left')}: ${({
  isButtonLogo,
}) => (isButtonLogo ? 8 : 16)}px;
  @media screen and (max-width: 350px) {
    margin-top: 32px;
  }
`

export const MintButton = styled.button<{ isSecond?: boolean }>`
  border-radius: 8px;
  border: 1px solid;
  padding: 4px 16px;
  /* position: absolute; */

  background: ${({ theme }) =>
    getRgbaValue(theme.semantics.zap.surface.primary, 0.1)};
  left: ${({ isSecond }) => (isSecond ? 208 : 32)}px;
  @media (max-width: 1000px) {
    top: 80px;
  }
`

export const ConnectButton = styled.button`
  background-color: ${(props) => props.theme.colors.brandPrimary};
  color: #040b0e;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.18px;
  text-transform: uppercase;
  ${defaultTransition}

  border-radius: 4px;
  padding: 0px 32px;
  height: 56px;
  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`

export const Desktop = styled(Box)`
  margin-left: auto;
  @media screen and (max-width: 1000px) {
    display: none;
  }
`

export const SpinningLogo = styled.img`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`

export const ActionButton = styled.button`
  display: inline-flex;
  height: 52px;
  padding: 18px 24px 19px 24px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(0, 0, 0, 0.7);
  :hover {
    cursor: pointer;
    filter: brightness(0.7);
  }
`

export const RewardsAmount = styled(Box)`
  justify-content: center;
  align-items: center;
  flex: 0;
  min-width: 28px;
  height: 28px;
  background: #f4ed0c;
  border-radius: 4px;
  font-size: 14px;
  color: white;
  margin-left: 8px;
  font-family: 'Space Grotesk';
  color: #000;
  font-weight: 700;
`

export const ExternalLinkButton = styled.div`
  a {
    ${linkStyles}
  }
`

export const LinkButton = styled.div`
  ${linkStyles}
`

export const MobileMenu = styled.div`
  min-height: 100dvh;
  width: 100dvw;
  padding: 28px 16px;

  display: flex;
  flex-direction: column;

  background: linear-gradient(black, transparent), url(/hero-cover-labs.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-color: black;
  background-position: center;
  background-blend-mode: luminosity;
`

export const MobileMenuBox = styled(Box)`
  padding-bottom: 76px;
  height: 100%;
`
export const WalletMenuBox = styled(Box)`
  position: absolute;
  // sorry for the rawdog - transparent doesn't work great here
  background: #171717 !important;
  top: 0;
  right: -4px;
  z-index: 1000;
  padding: 16px;
  border-radius: 16px;
`

export const WalletMenuItem = styled(Box)`
  > * {
    padding: 4px;
    width: 100%;
    text-align: left;
    color: #fff;
    font-feature-settings: 'ss01' on;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.14px;
  }
`

export const WalletMenuDivider = styled.hr`
  height: 1px;
  width: 100%;
  border: none;
  background: rgba(255, 255, 255, 0.2);
`

export const BoxLeft = styled(Box)`
  flex-shrink: 0;
`

export const BoxRight = styled(Box)`
  gap: 36px;
  flex-wrap: wrap-reverse;

  @media screen and (max-width: 1250px) {
    gap: 16px;
  }
`

export const Warning = styled.div`
  background-color: ${({ theme }) => theme.colors.red};
  padding: 16px;
  position: relative;
  z-index: 10;

  color: #000;
  text-align: center;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  b {
    font-weight: 700;
  }
`

export const DeploymentWarning = styled(Box)`
  background-color: #ffff00;
`

export const StickyToggleStakingCont = styled(Box) <{ isHidden?: boolean }>`
  position: fixed;
  top: 18px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: ${({ isHidden }) =>
    isHidden ? 'translateY(-500%)' : 'translateY(0)'};

  // careful if you change this, its to allow clicking on other things on the header / zindex
  z-index: 2;
  max-width: 210px;
  margin: auto;
`
